.stat { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.label { font-size: var(--text-xs); font-weight: var(--weight-medium); color: var(--color-text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; }
.value { font-size: var(--text-xl); font-weight: var(--weight-semibold); font-variant-numeric: tabular-nums; letter-spacing: var(--tracking-tight); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lg .value { font-size: var(--text-3xl); font-weight: var(--weight-bold); }
.sm .value { font-size: var(--text-md); }
.hint { font-size: var(--text-xs); color: var(--color-text-tertiary); }
